import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth.jsx";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId });
        // Session cookie is now set. Refresh AuthContext, then hard-navigate to /hjem.
        // Use a cache-buster query so the browser always performs a fresh navigation even
        // if the current URL differs only by hash fragment.
        await refresh();
        window.location.replace("/hjem?_login=" + Date.now());
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-zinc-300">
      <div className="text-center">
        <div className="font-score text-5xl">FM27</div>
        <div className="mt-4 text-zinc-500">Logger dig ind…</div>
      </div>
    </div>
  );
}
